import {resources, scopes} from '../../../permissions/dictionary';
import {paths} from '../../../dictionaries/urls';

export const maintenance = [{
  'name': 'Proveedores',
  'path': paths.ProvidersList,
  'resource': resources.Providers,
  'scopes': [scopes.See],
  'icon': 'supplier',
}, {
  'name': 'Orígenes',
  'path': paths.OriginsList,
  'resource': resources.Origins,
  'scopes': [scopes.See],
  'icon': 'origins',
}, {
  'name': 'Repuestos',
  'path': '/maestro-repuestos',
  'resource': resources.PartsMaster,
  'scopes': [scopes.Create],
  'icon': 'partsMaster',
}, {
  'name': 'Descripción Ajustes de Stock',
  'path': '/ajuste-stock-mantenimiento-descripcion',
  'resource': resources.DescriptionMantainStockAdjustment,
  'scopes': [scopes.Edit],
  'icon': 'partsMaster',
}, {
  'name': 'Calendario',
  'path': paths.TdeCalendar,
  'resource': resources.TdeCalendar,
  'scopes': [scopes.See],
  'icon': 'calendar',
}, {
  'name': 'Presupuesto Repuestos',
  'path': paths.ItemBudget,
  'resource': resources.ItemBudget,
  'scopes': [scopes.Edit],
  'icon': 'budget',
}, {
  'name': 'Combos',
  'path': paths.CombosList,
  'resource': resources.CombosManagement,
  'scopes': [scopes.Edit, scopes.See],
  'icon': 'related',
}, {
  'name': 'Couriers/Transportistas',
  'path': paths.TransportistManagement,
  'resource': resources.TransportistManagement,
  'scopes': [scopes.Edit, scopes.See],
  'icon': 'related',
}, {
  'name': 'Agencias',
  'path': paths.AgenciesManagement,
  'resource': resources.AgenciesManagement,
  'scopes': [scopes.Edit, scopes.See],
  'icon': 'related',
},
];

export const purchases = [{
  'name': 'Consulta de Facturas',
  'path': paths.InvoiceQuery,
  'resource': resources.InvoiceQuery,
  'scopes': [scopes.See, scopes.Create],
  'icon': 'invoiceSearch',
}, {
  'name': 'Ingreso de Facturas',
  'path': paths.InvoiceLoad,
  'resource': resources.InvoiceLoad,
  'scopes': [scopes.Create],
  'icon': 'invoice',
}, {
  'name': 'Gestión de Pedidos a Proveedores',
  'path': paths.ProviderOrdersManagement,
  'resource': resources.ProviderOrdersManagement,
  'scopes': [scopes.See],
  'icon': 'providerOrdersManagement',
}, {
  'name': 'Pedidos de Stock a Proveedores',
  'path': paths.ProviderStockOrders,
  'resource': resources.ProviderStockOrders,
  'scopes': [scopes.Create],
  'icon': 'providerStockOrder',
}, {
  'name': 'Pedidos Especiales a Proveedores',
  'path': paths.ProviderSpecialOrders,
  'resource': resources.ProviderSpecialOrders,
  'scopes': [scopes.Create],
  'icon': 'providerSpecialOrders',
}, {
  'name': 'Pedidos Manuales a Proveedores',
  'path': paths.ProviderManualOrders,
  'resource': resources.ProviderManualOrders,
  'scopes': [scopes.Create],
  'icon': 'ProviderManualOrders',
}, {
  'name': 'Configuración Secuencias Pedidos a Proveedores',
  'path': paths.ProviderOrdersSequenceConfig,
  'resource': resources.ProviderOrdersSequenceConfig,
  'scopes': [scopes.Create],
  'icon': 'providerOrdersSequenceConfig',
}];

export const query = [
  {
    'name': 'Consulta Auditoría Partes',
    'path': paths.PartAudit,
    'resource': resources.PartAudit,
    'scopes': [scopes.See],
    'icon': 'partsAudit',
  },
];
